import React, { useState } from "react";
import { SpinnerSize, TooltipHost } from '@fluentui/react';
import { OverflowSet } from '@fluentui/react/lib/OverflowSet';
import List from '../../../../Templates/List';
import DisabledCard from '../../../../Templates/CCard/DisabledCard';
import { useTranslation } from "react-i18next";
import { Card, Row, Col } from "react-bootstrap"
import { useGetMessagesByBookByMessage } from '../../../../../hooks/services/sBook/useOfMessajeEvent'
import NoDataLayer from "../../../../Common/NoDataLayer";
import moment from "moment-timezone"
import ListPagination from "../../../../Templates/List/ListPagination";
import SidePanelViewCommentEvent from "../../MessageEventsBox/SidePanelViewCommentEvent";
import { getAllMessageEventByBookAndMessageExcelData } from "../../../../../services/sBook/message-log.service";
import { __onRenderOverflowButton, __onRenderOverflowItem } from '../../../../../common/CommonFuctions';
import * as XLSX from 'xlsx';
import { convertToLocalClientTimeZone } from "../../../../../common/Helpers";
import './style.css'
import Loading from "../../../../Templates/Site/Loading";
function MessageEventsBox(props) {
    const { t } = useTranslation();

    //Parametros de entrada.
    const inputParam_BookObject = props.bookObject;
    const inputParam_MessageObject = props.messageObject !== null && props.messageObject !== undefined ? props.messageObject : false;
    const inputParam_FireUpdateBoxListMessageEventControl = props.fireUpdateBoxListMessageEventControl !== null && props.fireUpdateBoxListMessageEventControl !== undefined ? props.fireUpdateBoxListMessageEventControl : false;
    const inputParam_SetterFireUpdateBoxListMessageEventControl = props.settetFireUpdateBoxListMessageEventControl !== null && props.settetFireUpdateBoxListMessageEventControl !== undefined ? props.settetFireUpdateBoxListMessageEventControl : false;
    const inputParam_UserProps = props.userProps !== null && props.userProps !== undefined ? props.userProps : null;
    const inputParam_MessageCounts = props.messageCounts !== null && props.messageCounts !== undefined ? props.messageCounts : null;
    

    //Parametros de componente.
    const [isPanelOpen, setIsPanelOpen] = useState(false);
    const [selectedMessageEvent, setSelectedMessageEvent] = useState(false);

    const [messageEventList, setMessageEventList] = useState({fireUpdate: true, data: null, pageNumber: 1, pageSize: 10, filters: []});
    useGetMessagesByBookByMessage(
        inputParam_BookObject.id,
        inputParam_MessageObject ? inputParam_MessageObject.id : null,
        inputParam_FireUpdateBoxListMessageEventControl,
        setMessageEventList,
        inputParam_SetterFireUpdateBoxListMessageEventControl
    );

    const handleExport = () => {  
        getAllMessageEventByBookAndMessageExcelData(inputParam_BookObject.id, inputParam_MessageObject.id).then((serviceResponse) => {
            const workbook = XLSX.utils.book_new(); 
            const headers = serviceResponse.data.headers;

            const aux_rows = serviceResponse.data.data.map(row => {
                const transformedRow = {};
                for (const key in row) {
                    if (headers[key]) {
                        if (key === "messageEventDate") {
                            transformedRow[t(headers[key])] = moment(row[key]).format("DD/MM/YYYY") ;
                        }
                        else {
                            transformedRow[t(headers[key])] = row[key].startsWith("data-lang-sbmessageevent-") ? t(row[key]) : row[key];
                        }
                    }
                }
                return transformedRow;
            });

            const worksheet = XLSX.utils.json_to_sheet(aux_rows);
            
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');
            XLSX.writeFile(workbook, `${t('data-lang-lbl-messageevent')} - ${serviceResponse.data.messageTitle}.xlsx`);

            //handleDownload(serviceResponse.data, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,");
        });
    };

    const onRenderRow = (props, defaultRender) => {
        return defaultRender({
            ...props,
            className: props?.item.messageEventName === "data-lang-sbmessageevent-type-comment-visa" ? 'commentVisaDecoration' : undefined,
        });
    }

    const onSelectMessageClick = (messageEvent) => {
        setSelectedMessageEvent(messageEvent)
        setIsPanelOpen(true);
    }


    const _columns = (messageEventList && messageEventList.data && inputParam_BookObject.id !== null && inputParam_MessageObject !== null) ? [
        {
            key: 'messageEventName',
            name: t('data-lang-lbl-type'),
            fieldName: 'messageEventName',
            minWidth: 120,
            className: 'columna-nombre',
            onRender:(item) => {

                if (item.messageEventName.toLowerCase() === "data-lang-sbmessageevent-type-comment" || item.messageEventName.toLowerCase() === "data-lang-sbmessageevent-type-comment-visa") {
                    const textToDisplay = item.messageEventDesc !== null ? (item.messageEventDesc.length > 70 ? `${item.messageEventDesc.slice(0, 70)}...`  : item.messageEventDesc) : "";

                    if (textToDisplay.length > 70) {
                        return  <div data-id={item.id} className="d-flex" >
                                    <div>{ t(item.messageEventName) }&nbsp;:&nbsp;</div>
                                    <TooltipHost content={ item.messageEventDesc } calloutProps={{
                                            gapSpace: 0,
                                            target: `#${'targetLabel' + item.id}`,
                                        }}>
                                        <div id={'targetLabel' + item.id}>{ textToDisplay }</div>
                                    </TooltipHost>
                                </div>
                    } else {
                        return  <div data-id={item.id} className="d-flex" >
                                    <div>{ t(item.messageEventName) }&nbsp;:&nbsp;</div>
                                    <div id={'targetLabel' + item.id}>{ textToDisplay }</div>
                                </div>
                    }
                } else {
                    return   <div data-id={item.id}>{t(item.messageEventName)}</div>
                }
            }
        },
        {  
            key: 'messageEventDate',
            name: t('data-lang-lbl-date'),
            fieldName: 'messageEventDate',
            minWidth: 170,
            maxWidth: 170,
            onRender:(item) => {
                return <div>{ convertToLocalClientTimeZone(item.messageEventDate) }</div>
            }
        },
        {  
            key: 'messageEventUsername',
            name: t('data-lang-lbl-user'),
            fieldName: 'messageEventUsername',
            onRender:(item) => {
                return <div title={item.messageEventUsername}>{ item.messageEventFullname }</div>
            }
        },
        {  
            key: 'id',
            name: t('data-lang-lbl-actions'),
            fieldName: 'id',
            minWidth: 60,
            maxWidth: 60,
            onRender:(item, row) => {


                const items = item.messageEventName.toLowerCase() === "data-lang-sbmessageevent-type-comment" || item.messageEventName.toLowerCase() === "data-lang-sbmessageevent-type-comment-visa" ? [
                    {
                        key: 'item1',
                        icon: 'View',
                        name: t('data-lang-btn-viewcomment'),
                        title: t('data-lang-btn-viewcomment'),
                        onClick: () => onSelectMessageClick(item),
                    }
                ] : [];
                


                return <div>
                        <OverflowSet
                            className="action-menu-list-toolbar d-flex justify-content-center list-menu-action"
                            role="menubar"
                            items={ items }
                            onRenderOverflowButton={__onRenderOverflowButton}
                            onRenderItem={__onRenderOverflowItem}
                        />
                </div>
            }
        }
    ] : [];

    const displayMessageEventsBox = inputParam_BookObject.id !== null ? true : false;

    return (
        <Card className='h-100'>
            <DisabledCard display={ !displayMessageEventsBox } />
            <Card.Header className="card-header-compact">
                <Card.Title className="d-flex justify-content-between">
                    <b>{t('data-lang-boxname-messageevents')}</b>
                </Card.Title>
            </Card.Header>
            {
                inputParam_MessageCounts === 0 && 
                <Card.Body className='overflow-auto card-body-no-padding h-100'>
                    <Row className="h-100">
                        <Col className="d-flex align-items-center justify-content-center">
                            <div>{t('data-lang-lbl-nomessages')}</div>
                        </Col>
                    </Row>
                </Card.Body>
            }
            {
                (inputParam_MessageCounts === null || inputParam_MessageCounts > 0) && 
                <>
                    {
                        (messageEventList && messageEventList.data) && 
                        <>
                            <Card.Body style={{width: "100%"}} className="overflow-auto h-100">         
                                <Row className='layerBlockedContent'>
                                    <Col>
                                        {
                                            displayMessageEventsBox &&
                                            <List
                                                listLocalStoragePageSizeVariableName="eventMessages"
                                                className="no-compact-list big-header"
                                                topValue="91.5%"
                                                manipulateLocalData={ true }
                                                data={ (messageEventList !== null ? messageEventList : []) }
                                                setData={ setMessageEventList } columns={ _columns }
                                                enableExport={ true }
                                                handleExport={ handleExport }
                                                inputParam_OnRenderRow={onRenderRow}
                                                exportFileName={"Eventos de mensaje.xlsx"} />   
                                        
                                        }
                                        <NoDataLayer display={ !displayMessageEventsBox } />
                                    </Col>
                                </Row>
                                <SidePanelViewCommentEvent
                                    messageEventObject={ selectedMessageEvent }
                                    isPanelOpen={ isPanelOpen }
                                    setterIsPanelOpen={ setIsPanelOpen }
                                />  
                            </Card.Body>
                            <Card.Footer>
                                {
                                    displayMessageEventsBox &&
                                    <ListPagination
                                        listLocalStoragePageSizeVariableName="eventMessages"
                                        data={ (messageEventList !== null ? messageEventList : []) }
                                        setData={ setMessageEventList }
                                    />
                                }
                            </Card.Footer>
                        </>
                    }
                    {
                        !(messageEventList && messageEventList.data) && 
                        <Card.Body className="book-party-roles-form-body h-100">
                            <Row className="h-100">
                                <Col className="d-flex align-items-center justify-content-center">
                                    <Loading
                                        inputParam_ShowLoading={true}
                                        inputParam_ShowText={false}
                                        inputParam_Width={'35px'}
                                        inputParam_Height={'35px'}
                                        inputParam_Left={""}
                                        inputParam_Style={{marginTop: 0}}
                                        inputParam_ColClassName={"me-2"}
                                        inputParam_MarginLeft={"auto"}
                                        inputParam_SpinnerSize={SpinnerSize.medium} />
                                </Col>
                            </Row>
                        </Card.Body>
                    }
                </>
            }
        </Card>
    );
}

export default MessageEventsBox;

